<template>
    <!-- TODO: bad key on preamble_effective_interest -->
    <!-- add class "col-lg-4"? see CreditCard.vue and CorporateLenderCard.vue -->
    <!-- Can this be made into a component? See similarities with components above -->
    <div class="col-12 col-md-6 col-lg-4 mb-5">
        <div class="card hover-translate-y-n10 hover-shadow-lg border">
            <card-header :lender-or-card="lender" />
            <card-image :image="lender.data.logo" width="150" />
            <card-trust-score 
                class="mx-3 mb-2" 
                :trust-score="model.trustpilotScore" 
                :trust-score-count="model.trustpilotRatingCount" 
            />

            <div class="card-body p-3 bg-light fs-6">
                <table-row 
                    :title="$translate('loan_amount', 'Belopp')" 
                    :value="amountToDisplay" 
                    :tooltip="amountToolTip"
                />
                <table-row 
                    :title="$translate('loan_duration', 'Löptid')" 
                    :value="$getDurationString(model, alternateDataConfig.dataType, alternateDataConfig.dataDisplay)"
                    :tooltip="$getLoanDurationTooltip(model, alternateDataConfig.dataType, alternateDataConfig.dataDisplay)"
                />
                <table-row 
                    v-if="!($isSpain() && model.isBroker)"
                    :title="$translate('preamble_effective_interest', 'Effektiv ränta')" 
                    :value="model.effectiveInterestString"
                    :tooltip="! model.hasFirstTimeOffer 
                        ? null 
                        : model.getFirstTimeOfferString(
                            $translate('first_time_offer_up_to_amount', 'Räntefritt upp till {amount} i {days} dagar för nya kunder'),
                            $translate('new_customers_offer_from_amount', 'Räntefritt från {amount} i {days} dagar för nya kunder')
                        )"
                />
                <template v-if="$isSweden()">
                    <table-row
                        v-if="model.isBroker" 
                        :title="$getConnectedBanksLabel(model)" 
                        :value="model.connectedBanks" 
                    />
                    <table-row 
                        v-else-if="model.maxAmount <= 50000 || model.isHighCostCredit" 
                        :title="$translate('direct_pay_out', 'Direktutbetalning')" 
                        :value="model.hasDirectPayments24Hours ? $translate('around_the_clock', 'Dygnet runt') : 
                            model.hasDirectPayments ? $translate('direct', 'Direkt') :
                            $translate('no', 'Nej')" 
                    />
                    <table-row 
                        v-else 
                        :title="$translate('arrangement_fee', 'Uppläggningsavgift')" 
                        :value="model.setupFeeString" 
                    />
                    <table-row 
                        :title="$translate('without_uc', 'Utan UC')" 
                        :value="$formatBoolean(!model.takesUC)"
                        :tooltip="$getCreditCheckTooltip(lender, model)"
                    />
                    <table-row 
                        :title="$translate('payment_remarks', 'Betalningsanmärkning')" 
                        :value="model.acceptsPaymentRemarks ? $translate('accepted', 'Accepteras') : $translate('not_accepted', 'Accepteras inte')"
                        :tooltip="model.acceptsPaymentRemarks && model.paymentRemarksMaxCount ? `Max ${model.paymentRemarksMaxCount} st` : null" 
                    />
                </template>
                <template v-else-if="$isNorway()">
                    <table-row title="Bank-ID" :value="$formatBoolean(model.hasBankId)" />
                    <table-row :title="$translate('payment_remarks', 'Betalningsanmärkning')" :value="model.acceptsPaymentRemarks ? $translate('accepted', 'Accepteras') : $translate('not_accepted', 'Accepteras inte')" />
                </template>
                <template v-else-if="$isEstonia()">
                    <!-- TODO: Estonia setup smart id? Have more stuff? -->
                    <!-- <table-row title="Smart ID" value="Ja" /> -->
                    <table-row :title="$translate('arrangement_fee', 'Uppläggningsavgift')" :value="model.getEstonianSetupFeeString()" />
                </template>
                <template v-else-if="$isSpain()">
                    <table-row 
                        v-if="model.isBroker"
                        :title="$translate('preamble_effective_interest', 'Effektiv ränta')" 
                        :value="model.effectiveInterestString"
                        :tooltip="$translate('spain_interest_tooltip_on_broker')"
                    />
                    <table-row 
                        :title="$translate('spain_loan_type', 'Loan type')" 
                        :value="model.isBroker ? $translate('spain_loan_type_broker', 'Broker') : $translate('spain_loan_type_lender', 'Lender')"
                    />
                    <table-row :title="$translate('no_salary', 'Utan inkomst från lön')" :value="$formatBoolean(model.acceptsNoSalary)" />
                    <table-row :title="$translate('with_asnef', 'With ASNEF')" :value="$formatBoolean(model.acceptsASNEF)" />
                </template>
                <table-row 
                    :title="$translate('min_age', 'Åldersgräns')" 
                    :value="model.minAge + ' ' + $translate('years', 'år')"
                />
            </div>

            <div v-if="model.isAffiliateBroker" class="small p-3 pt-0 bg-light lh-sm">
                <i class="bi bi-info-circle me-1 text-primary" /> 
                {{ 
                    $translate(
                        'affiliate_broker_data_disclaimer', 
                        '{lender} är en jämförelsetjänst, all data beror på den långivare du väljer att starta en ansökan med.'
                    ).replace('{lender}', lender.data.title)
                }}
            </div>

            <card-links :lender-or-card="lender" :position="position" />

            <card-information 
                :compliance-example="model.complianceExample" 
                :is-high-cost-credit="model.isHighCostCredit"
                :lender="lender"
            />
        </div>
    </div>
</template>
<script>
import CardHeader from './CardHeader.vue';
import CardImage from './CardImage.vue';
import TableRow from './TableRow.vue';
import CardLinks from './CardLinks.vue';
import CardInformation from './CardInformation.vue';
import CardTrustScore from './CardTrustScore.vue';

export default {
    components: {
        CardHeader,
        CardImage,
        TableRow,
        CardLinks,
        CardInformation,
        CardTrustScore
    },
    props: {
        lenderId: {
            type: String,
            required: true
        },
        position: {
            type: Number,
            required: false,
            default: null
        },
        alternateDataConfig: {
            type: Object,
            required: false,
            default: () => ({})
        },
        fixedAmount: {
            type: Number,
            required: false,
            default: null
        }
    },
    computed: {
        lender() {
            return this.$store.state.lenders[this.lenderId];
        },
        model() {
            return new this.$models.Loan(this.lender);
        },
        alternateDataKeys() {
            return this.$getAlternateDataKeys(this.alternateDataConfig);
        },
        amountString() {
            return this.model[this.alternateDataKeys.amountString]
        },
        amountToDisplay() {
            return this.fixedAmount 
                ? this.$format.currency(this.fixedAmount)
                : this.amountString;
        },
        amountToolTip() {
            return this.fixedAmount 
                ? this.amountString
                : this.$getLoanAmountTooltip(this.model, this.alternateDataConfig.dataType, this.alternateDataConfig.dataDisplay);
        }
    },
};
</script>